import { AdjustmentStatuses } from 'constants/adjustmentStatuses';

import { styled } from '@mui/material/styles';
import { ChipField } from 'react-admin';

export const ChipFieldStyled = styled(ChipField)<{
  status: AdjustmentStatuses;
}>(({ theme, status }) => ({
  backgroundColor: theme.palette.status.adjustmentStatus[status],
  color: theme.palette.common.white,
  margin: '0 !important',
  height: '24px',
}));
